var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFfpcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 138.7 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.22 34.31v-18.95h-11.08l3.89 9.57-3.89 9.39h11.08z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.49 15.66v18.95h11.07l-3.89-9.58 3.89-9.38h-11.07z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.86 20.3v-4.57h-19.85v19h5.83v-6.48h13.39v-4.41h-13.39v-3.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.49 20.3v-4.57h-19.84v19h5.83v-6.48h13.36v-4.41h-13.36v-3.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.38 22.73c.05-5.38-1.03-7.17-9.32-7.17h-6.83c-5.25 0-8.37 1.27-8.37 6.83v5.74c0 5.52 3.12 6.83 8.37 6.83h9.39c5.85 0 7.01-2.52 7.01-5.71v-1.79h-5.83c0 2.37-.78 2.63-3.41 2.63h-6.22c-2.76 0-3.34-1.05-3.34-3.81v-2.04c0-2.36.61-3.81 3.65-3.81h6.34c1.73 0 2.72.4 2.72 1.76v.53h5.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.24 15.73h-15.87v19.01h5.81v-4.78h11.56c4.09 0 5.33-3.25 5.33-6.09v-1.63c0-3.72-1.29-6.51-6.83-6.51zm.83 8.28c-.08.25-.22.48-.4.67s-.4.34-.65.43c-.24.09-.51.13-.77.11h-9.05v-4.77h8.56c1.76 0 2.39.73 2.39 2.01v.76c.03.26.01.53-.07.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.56 41.08h-116.45v-32.16h116.45v32.17zm-114.28-2.16h112.11v-27.84h-112.11v27.83z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfpcLogo);
export default __webpack_public_path__ + "static/media/ffpc-logo.7ce8d589752ed5a6394bf4d6fa70a933.svg";
export { ForwardRef as ReactComponent };